import {
  Navigate,
  useLocation,
  Link
} from 'react-router-dom'
import { URLs, useAuthStatus } from '../auth'
import { safeReturnPath } from '../lib/sso'

export default function ProviderCallback () {
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  const error = params.get('error')
  const [, status] = useAuthStatus()
  const next = safeReturnPath(params.get('next'))

  if (!error && status.isAuthenticated) {
    return <Navigate to={next} replace />
  }
  const url = `${URLs.LOGIN_URL}?${new URLSearchParams({ next, error: 'sso_failed' })}`
  return (
    <>
      <h1>Third-Party Login Failure</h1>
      <p>Something went wrong.</p>
      <Link to={url}>Continue</Link>
    </>
  )
}
